import { createAction, props } from "@ngrx/store";
import { ProposalBillingItem } from "app/entities";

export const loadProposalBillingItems = createAction(
    '[Proposal Billing Item] Load',
    props<{ proposalId: number }>()
);

export const loadProposalBillingItemsSuccess = createAction(
    '[Proposal Billing Item] Load Success',
    props<{ proposalId: number, items: ProposalBillingItem[] }>()
);

export const loadProposalBillingItemsFailure = createAction(
    '[Proposal Billing Item] Load Failure',
    props<{ error: any }>()
);

export const clearProposalBillingItems = createAction(
    '[Proposal Billing Item] Clear'
);

export const billProposalBillingItem = createAction(
    '[Proposal Billing Item] Bill',
    props<{ proposalId: number, itemId: number, date: Date }>()
);

export const billProposalBillingItemSuccess = createAction(
    '[Proposal Billing Item] Bill Success',
    props<{ proposalId: number, item: ProposalBillingItem }>()
);

export const billProposalBillingItemFailure = createAction(
    '[Proposal Billing Item] Bill Failure',
    props<{ error: any }>()
);

export const payProposalBillingItem = createAction(
    '[Proposal Billing Item] Pay',
    props<{ proposalId: number, itemId: number, date: Date }>()
);

export const payProposalBillingItemSuccess = createAction(
    '[Proposal Billing Item] Pay Success',
    props<{ proposalId: number, item: ProposalBillingItem }>()
);

export const payProposalBillingItemFailure = createAction(
    '[Proposal Billing Item] Pay Failure',
    props<{ error: any }>()
);
